import React from 'react';
import { useSelector} from "react-redux";
import {
    bbDoesUserHaveAccessToBreachRiskLevelForEntity,
    bbFindEntityWithinPortfolioOrSelf,
    mapObject
} from "../../../util/bbHelpers";
import PropTypes from "prop-types";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBDataTable from "../tables/BBDataTable";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import BBIconCheckCircleYes from "../../../assets/bbCustomIcons/BBIconCheckCircleYes";
import BBIconRoundedDashNull from "../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import {Badge} from "reactstrap";
import BBIconRadarSweepWithTargets from "../../../assets/bbCustomIcons/BBIconRadarSweepWithTargets";


const TableContainer = ({portfolioView = false, cycleId=null,}) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {entityInView, portfolios, loadingPortfolios, loadingPortfoliosError, loadingCycles, loadingCyclesError, loadingCycleDetails, loadingCycleDetailsError, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {authUser} = useSelector(({auth}) => auth);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const customer = customers ? customers[customerIdToUse] : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const isTrustedAgentForThisEntity = bbDoesUserHaveAccessToBreachRiskLevelForEntity(authUser, "infoLevel3", entityInView);

    const lastCycle = myEntity
    && myEntity.cycles
    && myEntity.settings
    && myEntity.settings.last_cycle_id
        ? myEntity.cycles[myEntity.settings.last_cycle_id] : null;

    const pastReportView = cycleId && lastCycle && cycleId !== lastCycle.id;

    const cycleInView = pastReportView
    && myEntity
    && myEntity.cycles
    && myEntity.cycles[cycleId]
        ? myEntity.cycles[cycleId]
        : lastCycle;

    const techData = myEntity
    && (lastCycle || cycleInView)
        ? cycleInView.techData
        : null;
    // console.log("techData from lastCycle", lastCycle, techData);
    
    const subdomains = techData
    && techData.totals
        ? techData.totals.subdomains
        : null;

    const totalNumRecords = techData
        && techData.meta
            ? techData.meta.subdomains_to_send
            : null;

    // console.log("subdomains is",subdomains)

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/

    const title = <div className={"tourStepBRReportVectorsTable"}>
        Subdomains Detected <Tooltip title={"Information for all subdomains found to be a part of your IT infrastructure."}>
            <InfoSharpIcon style={{fontSize: "smaller"}} className={``}/>
        </Tooltip>
    </div>;

    const description = <>Subdomains that we detect provide context on how attackers view the structure of your cyberspace.</>

  const userTableHeadings = [
      // { field: 'customerId', headerName: 'CID', hide: true, flex : 1, sortable: true, type: 'string', },
      { field: 'id', headerName: 'ID', hide: true, flex : 1, sortable: true, type: 'string', renderCell: (params) => {

              return params.value}},
      { field: 'name', headerName: 'Subdomain', hide: false, sortable: true, type: 'string', flex : 1, renderCell: (params) =>
              renderCellExpand(params, (<Tooltip title={``}>
                          <span>
                              {params.value}
                          </span>
                  </Tooltip>

              ))},
      { field: 'isActive', headerName: 'Active', hide: false, sortable: true, type: 'boolean', width: 110,
          renderCell: (params) =>
        renderCellExpand(params, (<>
                {params.value
                    ? <Tooltip title={`Service is Active`}>
                                  <span>
                                      <Badge color={"primary"}>Active</Badge>
                                  </span>
                    </Tooltip>
                    : <Tooltip title={`This service is not active`}>
                                  <span>
                                      <Badge color={"secondary"}>Inactive</Badge>
                                  </span>
                    </Tooltip>
                }
            </>

        ))},
      { field: 'discovered', headerName: 'Discovered',
          renderHeader: (params) =>
              renderCellExpand(params,
                  <div style={{lineHeight: "normal"}}>
                      <Tooltip title={"Discovered: whether or not this element was discovered by us."}>
                    <span>
                        <BBIconRadarSweepWithTargets/>
                    </span>
                      </Tooltip>
                  </div>),
          hide: false, sortable: true, type: 'boolean', width: 75, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`We detected this element.`}>
                                  <span>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This element was not detected by our most recent discovery methods.`}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},
      { field: 'provided', headerName: 'Provided', hide: false, sortable: true, type: 'boolean', width: 110, renderCell: (params) =>
              renderCellExpand(params, (<>
                      {params.value
                          ? <Tooltip title={`You or someone from your company provided this element.`}>
                                  <span className={"text-center"}>
                                    <BBIconCheckCircleYes className={'text-bb-risk-low'}/>
                                  </span>
                          </Tooltip>
                          : <Tooltip title={`This element was not provided by your company, it was discovered by BreachBits.`}>
                                  <span className={"text-center"}>
                                    <BBIconRoundedDashNull/>
                                  </span>
                          </Tooltip>
                      }
                  </>

              ))},

  ];

    //peel the state data into a form the dataTable can read
  const tableData = subdomains && Array.isArray(subdomains) ? subdomains.map((object) => {

      return (
        {
            customerId: customer.CustomerId,
            id: object.id,
            idShort: object.id.slice(0, 6),
            name: object.subdomain,
            isActive: object.is_active,
            crawls:  object.crawls ? Object.keys(object.crawls).length : 0, //an object of stuff prob just do a count for now
            domainId: object.domain,
            provided: object.provided,
            discovered: object.discovered,

        }
    )
  }) : null;

    // const tableDataAsArray = () => {
    //     // console.log("Creating humansTableData as array from humanTableData ", tableData);
    //     let arr=[];
    //     for (let ob in tableData) {
    //         // console.log("ob is ", tableData[ob])
    //         arr.push(tableData[ob]);
    //     }
    //     // console.log("resulting array ", arr);
    //     return arr;
    // }


    return (
        <div >
            {(((subdomains && Array.isArray(subdomains)) || totalNumRecords === 0)
                && myEntity
                && myEntity.settings
                && customerIdToUse
                && !loadingPortfoliosError[customerIdToUse]
                && !loadingPortfolios[customerIdToUse]
                && !loadingCycles[myEntity.settings.last_cycle_id]
                && !loadingCyclesError[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetails[myEntity.settings.last_cycle_id]
                // && !loadingCycleDetailsError[myEntity.settings.last_cycle_id]
            ) ?
            <BBDataTable
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={tableData}
                totalRows={totalNumRecords}
                progressValue={totalNumRecords === 0 ? 100 : subdomains.length / totalNumRecords * 100}
                bufferValue={totalNumRecords === 0 ? 100 : subdomains.length / totalNumRecords * 100 + 10}
                title={title}
                description={description}
                enableExport
                loading={false}
                // requiresModule={"monitor"}
                requiresBRLevel = {"infoLevel3"}
                authUser = {authUser}
                entityId = {entityInView}
                customer={customer}
                // topRightElement={<BBModuleIcon includeTooltip module={bbGetModulePropertyFromIdOrName("monitor", "id")} isActive={bbDoesCustomerHaveAccessToModule(customer, "monitor")} iconSize={"40px"}/>}
                defaultSortModel = {[
                    {
                        field: 'name',
                        sort: 'asc',
                    },

                ]}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
                elementDisplayNameForConsoleLogs={`BRSubdomainsTechnicalTable`}
            />
            :
            <BBDataTable
                subscriptionNameOrId={portfolioView ? "BRP" : "BRfB"}
                columns={userTableHeadings}
                rows={[]}
                title={title}
                description={description}
                loading = {true}
                progressValue={0}
                bufferValue={15}
                rowsPerPageOptions = {[10, 25, 50, 100]}
                defaultPageSize = {10}
                lite={!portfolioView}
                // portfolioStarter={!isTrustedAgentForThisEntity}
                portfolioView={portfolioView}
            />
            }
        </div>
    );



}
TableContainer.propTypes = {
    customerId: PropTypes.string,
};

export default TableContainer